import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CommoditiesProvider as Provider } from '../../components/context/commodities-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllCommoditiesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Commodities" } }) {
    nodes {
      data
    }
  }
}
`;

export const CommoditiesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
